import useApiQuery from 'shared/hooks/use-api-query';
import {UserProps} from '../types';

const useUserByPhone = (phone?: string) => {
  const {data, ...query} = useApiQuery<UserProps>({
    url: `/users/phone/${phone}`,
    enabled: !!phone && phone.length >= 10,
  });

  return {data, ...query};
};

export default useUserByPhone;
